// without  caching
import React from 'react';
import logo from '../../../Assets/Announcement/images/hero-image-converted.png';
import announcementIcon from '../../../Assets/Announcement/Assets-Desktop/megaphone.svg';
import vesselStatusIcon from '../../../Assets/Announcement/Assets-Desktop/vessel_status.svg';
import dropdownarrow from '../../../Assets/Announcement/Assets-Desktop/down_arrow.svg';
import weatherIcon from '../../../Assets/Announcement/Assets-Desktop/cloudy.svg';
import preferencesIcon from '../../../Assets/NominateRequest/preferences.svg';
import nominateIcon from '../../../Assets/NominateRequest/nominateRequest.svg';
import container_status_icon from '../../../Assets/ContainerStatus/Assets_Desktop/container-status-icon.svg';
import Preadvise from '../../../Assets/TruckVisits/Assets-Desktop/pre-advise.svg';
import TruckAppointment from '../../../Assets/TruckVisits/Assets-Desktop/truck-appointment.svg';
import TruckVisits from '../../../Assets/TruckVisits/Assets-Desktop/truck-visits.svg';
import TPTQuotationIcon from '../../../Assets/TerminalHandling/requestTPTQuotation.svg';
import TFRIcon from '../../../Assets/TerminalHandling/requestRailQuotation.svg';
import RequestIcon from '../../../Assets/TerminalHandling/requestQuotation.svg';
import submitRequestIcon from '../../../Assets/TerminalHandling/submitRequest.svg';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../css/Home/Home.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import ProfileModal from '../../Shared/ManageProfileModal';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { Link } from 'react-router-dom';
import { AES, enc } from 'crypto-js';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL,imagePath } from '../../../Services/config/apiGateway';
import { ADVERTISEMENTS_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { success } from '../../../Redux/_actions/container.actions';
import { connect } from 'react-redux';
import ImageLoader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Cookies from 'cookies-js';
import { successManageProfile } from "../../../Redux/_actions/manageProfile.action";
import { release } from '../../../Services/utils/appMode';
var decodeImage = [];

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      decodeImageData: [],
      ImageLoaderTime: true,
      hasOpen: false,
      iconcheck: false,
      advertisementData: [],
      hashOPenValue: false,
      userType: '',
      loaded: true,
      staticAdd: false,
      permissionsValue: false,
      imagePath: imagePath,
      hasOpentermsCondition: false,
      hasOpenterms: false,
      previewTiles: [],
      premiumTiles: [],
      permissions: [],
      tilesData: [
        {
          "functionId": 21,
          "function": "ANNOUNCEMENT",
          "functionMeaning": "To View Announcement for External User",
          "functionDisplayName": "Announcement",
          "method": null,
          "activeFromDate": 1624559400000,
          "activeToDate": 0,
          "imgSrc": announcementIcon,
          "destPage": `/announcements`,
          "tileUserType": 'Preview'
        },
        {
          "functionId": 2,
          "function": "CONTAINER_STATUS_PREV",
          "functionMeaning": "Preview - To show the Container Status",
          "functionDisplayName": "Container status",
          "method": null,
          "activeFromDate": 1624559400000,
          "activeToDate": 0,
          "imgSrc": container_status_icon,
          "destPage": "/containerStatus",
          "tileUserType": 'Preview'
        },
        // {
        //   "functionId": 3,
        //   "function": "CONTAINER_STATUS_PREM",
        //   "functionMeaning": "Premium - To Show the Container Status",
        //   "functionDisplayName": "Container status",
        //   "method": null,
        //   "activeFromDate": 1624559400000,
        //   "activeToDate": 0,
        //   "imgSrc": container_status_icon,
        //   "destPage": "/containerStatus",
        //   "tileUserType": 'Premium'
        // },
        // {
        //   "functionId": 23,
        //   "function": "PRE_ADVISE",
        //   "functionMeaning": "Pre Advise for Internal User",
        //   "functionDisplayName": "Pre-advise",
        //   "method": null,
        //   "activeFromDate": 1624559400000,
        //   "activeToDate": 0,
        //   "imgSrc": Preadvise,
        //   "destPage": "/PreAdviseHome",
        //   "tileUserType": 'Premium'
        // },
        // {
        //   "functionId": 5,
        //   "function": "NOMINATE REQUEST",
        //   "functionMeaning": "Service Type",
        //   "functionDisplayName": "Nominate Request",
        //   "method": null,
        //   "activeFromDate": 1624559400000,
        //   "activeToDate": 0,
        //   "imgSrc": nominateIcon,
        //   "destPage": "/home",
        //   "tileUserType": 'Premium'
        // },
        // {
        //   "functionId": 20,
        //   "function": "PREFERENCES",
        //   "functionMeaning": "To set preference for Nominate Request",
        //   "functionDisplayName": "Preferences",
        //   "method": null,
        //   "activeFromDate": 1624559400000,
        //   "activeToDate": 0,
        //   "imgSrc": preferencesIcon,
        //   "destPage": this.props.manageProfileDataR?.selectedProfileType === "Requester"
        //     ? "/preferencesRequester" : (this.props.manageProfileDataR?.selectedProfileType === "Respondent"
        //       ? "/preferencesRespondent" :
        //       (this.props.manageProfileDataR?.selectedProfileType === "Driver" ? "/preferencesDriver" : '')),
        //   "tileUserType": 'Premium'
        // },
        // {
        //   "functionId": 28,
        //   "function": "REQUEST_SERVICE",
        //   "functionMeaning": "For Requester profile",
        //   "functionDisplayName": "Request Service",
        //   "method": null,
        //   "activeFromDate": 1629916200000,
        //   "activeToDate": 0,
        //   "imgSrc": RequestIcon,
        //   "destPage": "/ServiceSelection", // market place service req
        //   "tileUserType": 'Premium'
        // },
        //  {
        //   "functionId": 29,
        //   "function": "SUBMIT_REQUEST",
        //   "functionMeaning": "Submit request for respondent profile",
        //   "functionDisplayName": "Submit Request",
        //   "method": null,
        //   "activeFromDate": 1629916200000,
        //   "activeToDate": 0,
        //   "imgSrc": submitRequestIcon, // market place service req
        //   "destPage": "/ServiceRequest",
        //   "tileUserType": 'Premium'
        // },
        // {
        //   "functionId": 25,
        //   "function": "REQUEST_TPT_QUOTATION",
        //   "functionMeaning": "To request TPT Quotation for External user",
        //   "functionDisplayName": "Request TPT Quotation",
        //   "method": null,
        //   "activeFromDate": 1626373800000,
        //   "activeToDate": 0,
        //   "imgSrc": TPTQuotationIcon,
        //   "destPage": "/TPTRequestHistory",
        //   "tileUserType": 'Premium'
        // },
        // {
        //   "functionId": 26,
        //   "function": "REQUEST_RAIL_QUOTATION",
        //   "functionMeaning": "To request rail quotation for external user",
        //   "functionDisplayName": "Request Rail Quotation",
        //   "method": null,
        //   "activeFromDate": 1626373800000,
        //   "activeToDate": 0,
        //   "imgSrc": TFRIcon,
        //   "destPage": "/RailQuotationHistory",
        //   "tileUserType": 'Premium'
        // },
        // {
        //   "functionId": 8,
        //   "function": "TRUCK_APPOINTMENT",
        //   "functionMeaning": "Truck Appointment for External user",
        //   "functionDisplayName": "Truck Appointment",
        //   "method": null,
        //   "activeFromDate": 1624559400000,
        //   "activeToDate": 0,
        //   "imgSrc": TruckAppointment,
        //   "destPage": "/truckAppointment",
        //   "tileUserType": 'Premium'
        // },
        {
          "functionId": 9,
          "function": "TRUCK_VISIT_PREV",
          "functionMeaning": "Truck Visit for Preview User",
          "functionDisplayName": "Truck Visit",
          "method": null,
          "activeFromDate": 1624559400000,
          "activeToDate": 0,
          "imgSrc": TruckVisits,
          "destPage": '/truckVisit',
          "tileUserType": 'Preview'
        },
        // {
        //   "functionId": 10,
        //   "function": "TRUCK_VISIT_PREM",
        //   "functionMeaning": "Truck Visit for Premium User",
        //   "functionDisplayName": "Truck Visit",
        //   "method": null,
        //   "activeFromDate": 1624559400000,
        //   "activeToDate": 0,
        //   "imgSrc": TruckVisits,
        //   "destPage": '/truckVisit',
        //   "tileUserType": 'Premium'
        // },
        {
          "functionId": 6,
          "function": "VESSEL_STATUS_PREV",
          "functionMeaning": "Vessel Status for preview user",
          "functionDisplayName": "Vessel Status",
          "method": null,
          "activeFromDate": 1624559400000,
          "activeToDate": 0,
          "imgSrc": vesselStatusIcon,
          "destPage": "/vessel",
          "tileUserType": 'Preview'
        },
        // {
        //   "functionId": 7,
        //   "function": "VESSEL_STATUS_PREM",
        //   "functionMeaning": "Vessel Status for premium user",
        //   "functionDisplayName": "Vessel Status",
        //   "method": null,
        //   "activeFromDate": 1624559400000,
        //   "activeToDate": 0,
        //   "imgSrc": vesselStatusIcon,
        //   "destPage": "/vessel",
        //   "tileUserType": 'Premium'
        // },
        {
          "functionId": 4,
          "function": "WEATHER",
          "functionMeaning": "Weather Status",
          "functionDisplayName": "Weather",
          "method": null,
          "activeFromDate": 1624559400000,
          "activeToDate": 0,
          "imgSrc": weatherIcon,
          "destPage": "/weatherInformation",
          "tileUserType": 'Preview'
        },
      ]
    }
    this.tilesFetched = this.tilesFetched.bind(this);
  }
  tilesFetched = (val) => {
    if (val) {
      this.setState({ permissions: [] },
        this.afterDataReceived());
    }
  }
  afterDataReceived = () => {
    if (this.props.userProfileDataR?.userType === 'Preview' ||
      this.props.userProfileDataR?.userType === 'preview') {
      if (this.props.userProfileDataR?.profileRoles?.length > 0) {
        let previewIndex = this.props.manageProfileDataR?.selectedProfile;
        this.props.userProfileDataR?.profileRoles?.every((md, index) => {
          if (md.roleType.includes(this.props.manageProfileDataR?.selectedProfileType)) {
            previewIndex = index;
            return false
          }
          return true
        });
        this.setState({ permissions: this.props.userProfileDataR?.profileRoles[previewIndex]?.permissions }, () =>
          this.state.tilesData?.forEach((data, index) => {
            this.state.permissions?.find((x, i) => {
              if (data.functionId == x.functionId) {
                this.state.previewTiles.push({
                  imgSrc: data?.imgSrc,
                  title: x?.functionDisplayName,
                  destPage: data?.destPage,
                  tileUserType: data?.tileUserType,
                  functionId: x?.functionId
                })
              }
            })
          })
        )
      }
    }
    if (this.props.userProfileDataR?.userType === 'Premium' ||
      this.props.userProfileDataR?.userType === 'premium') {
      if (this.props.userProfileDataR?.profileRoles?.length > 0) {
        let rolesDataPremium = this.props.userProfileDataR?.profileRoles?.filter(role => !["Preview", "preview"].includes(role.roleType));
        this.setState({ permissions: rolesDataPremium[this.props.manageProfileDataR?.selectedProfile]?.permissions }, () =>
          this.state.tilesData?.forEach((data, index) => {
            this.state.permissions?.find((x, i) => {
              if (data.functionId == x.functionId) {
                this.state.premiumTiles.push({
                  imgSrc: data?.imgSrc,
                  title: x?.functionDisplayName,
                  destPage: data?.destPage,
                  tileUserType: data?.tileUserType,
                  functionId: x?.functionId
                })
              }
            })
          })
        )
      }
    }
  }
  componentDidMount = () => {
    window.$('.carousel-item').first().addClass('active');
    window.$('.carousel-indicators > li').first().addClass('active');
    this.setState({ permissions: [] },
      this.afterDataReceived()
    );
    // for container status redux states
    const containerData = {
      containerTerminalNameLS: '',
      containerNumberLS: '',
      billOfLadingNumberLS: ''
    }
    this.props.dispatch(success(containerData));
    this.setState({ userType: this.props.userProfileDataR?.userType });
    ApiCall(
      'GET',
      utilityBaseURL + ADVERTISEMENTS_ENDPOINT,
      {},
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    ).then((apiData) => {
      if (apiData.flag != -1) {
        if (apiData.flag == 500) {
          this.setState({ ImageLoaderTime: false });
          console.log("I am 500");
        }
        else {
          console.log('I am 200!');
          this.setState({ advertisementData: apiData, ImageLoaderTime: true });
          const testAccess = Cookies.get('_msAL');
          var count = 0;
          if (apiData?.length > 0) {
            apiData?.forEach((name, index) => {
              let ths = this;
              var xhr = new XMLHttpRequest();
              var URLToImage = this.state.imagePath + apiData[index].aDImageWebLink;
              xhr.open("GET", URLToImage, true);
              xhr.setRequestHeader("Authorization", 'Bearer' + ` ${testAccess}`);
              xhr.responseType = "arraybuffer";
              function imageLoadCallback() {
                ths.setState({ decodeImageData: decodeImage }
                  , () => {
                    ths.setState({
                      staticAdd: true
                      , ImageLoaderTime: false
                    });
                  });
                window.$('.carousel-item').first().addClass('active');
                window.$('.carousel-indicators > li').first().addClass('active');
                window.$('.carousel').carousel({
                  interval: 5000
                })
              }
              xhr.onload = function (e) {
                count = count + 1;
                // Obtain a blob: URL for the image data.
                var arrayBufferView = new Uint8Array(this.response);
                var blob = new Blob([arrayBufferView], { type: "image/jpg" });
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(blob);
                decodeImage[index] = imageUrl;
                if (count == apiData?.length) {
                  imageLoadCallback();
                }
              };
              xhr.send();
            })
          }
        }
      } else {
        this.setState({ ImageLoaderTime: false });
      }
    });
  }
  profileCheck = (event) => {
    this.props.history.push('/profileActivity');
  }
  onCloseModal = () => {
    this.setState({ hasOpen: false });
  };
  handelUser = () => {
    this.setState({ hasOpen: true });
    this.setState({ hashOPenValue: true });
  };
  onAddProfile = () => {
    this.props.history.push('/addProfile');
  };
  togglePasswordVisiblity = () => {
    this.setState({ iconcheck: !this.state.iconcheck });
  };
  onLoadImage = () => {
    console.log('loded');
  }
  handleAdvertisement = (event) => {
    this.state.advertisementData?.find((name) => {
      if (name.aDId === this.state.advertisementData[event].aDId) {
        if (name.aDLink.includes('http://') || name.aDLink.includes('https://')) {
          window.open(name.aDLink);
        }
        else {
          window.open('//' + name.aDLink);
        }
      }
    })
  }
  tilesAccess = (type) => {
    const data = {
      ...this.props.manageProfileDataR,
      tileUserType: type
    }
    this.props.dispatch(successManageProfile(data));
  }
  handleStaticAdvertisement = () => {
    window.open("//www.transnetportterminals.net/pages/default.aspx");
  }
  render() {
    return (
      <div className='outer' style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column' }}>
        <MetaDecorator title={TitleDescription.homePageTitle} description={TitleDescription.homePageDescription} />
        <Header tilesFetched={this.tilesFetched} />
        {/* for mobile view only */}
        <div class="pt-1 pl-1" id="mobilegroup1">
          <div onClick={release === '2' && this.handelUser}>
            <small class="" id="mobilecc" >Cargo Connect  </small>
            {release === '2' &&
            <img src={dropdownarrow}
              width="10" height="8" class=" pt-0" alt="" loading="lazy"
            />
    }
          </div>
          <div class="mobileheaderpreview">
            <small id="mobilepreview" >  {this.props.userProfileDataR?.userType === "Preview" ? this.props.manageProfileDataR?.selectedProfileType : (this.props.userProfileDataR?.userType === "Premium" ? this.props.manageProfileDataR?.selectedProfileType : '')} </small></div>
        </div>
        <div style={{ flex: 1 }} className='part4'>
          {this.state.ImageLoaderTime &&
            <div class="homeImageLoaderDivCss">
              <ImageLoader
                type="TailSpin"
                color="#000"
                height={60}
                width={60}
                visible={true}
              />
            </div>
          }
          {/* image loader */}
          <div id="myCarousel" class="carousel slide" data-ride="carousel">
            <ol class="carousel-indicators" id="circle">
              {this.state.staticAdd &&
                this.state.decodeImageData?.map((image, index) => {
                  return (
                    <li data-target="#myCarousel" data-slide-to={index}
                    ></li>
                  )
                })
              }
            </ol>
            <div class="carousel-inner">
              {this.state.staticAdd ?
                this.state.decodeImageData?.map((image, index) => {
                  return (
                    <div class="carousel-item">
                      <a onClick={() => this.handleAdvertisement(index)} target="_blank">
                        <img class="d-block w-100 carouselImg" id='photo'
                          src={image}
                          alt="slide"
                          onLoad={this.onLoadImage} />
                      </a>
                      <div class="text container" id="carouselText">
                      </div>
                    </div>
                  )
                })
                :
                <div class="carousel-item ">
                  <a onClick={() => this.handleStaticAdvertisement()} target="_blank">
                    <img class="d-block w-100 carouselImg" src={logo} alt="Static slide"
                      onLoad={this.onLoadImage} />
                  </a>
                  <div class="text container" id="carouselText">
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <div id='path' >
          <div class="forwaterm">
            <div className="part1">
              {this.props.userProfileDataR?.userType === "Premium" &&
                this.state.premiumTiles?.map((data, index) => {
                  return (
                    <div className='rectangle4' onClick={() => this.tilesAccess(data.tileUserType)}>
                      <Link to={data?.functionId == 20 ?
                        this.props.manageProfileDataR?.selectedProfileType === "Requester"
                          ? "/preferencesRequester" : (this.props.manageProfileDataR?.selectedProfileType === "Respondent"
                            ? "/preferencesRespondent" :
                            (this.props.manageProfileDataR?.selectedProfileType === "Driver" ? "/preferencesDriver" : ''))
                        :
                        data.destPage} className="decoration" style={{ textDecoration: 'none' }}>
                        <div className="card4">
                          <div class="tileicons">
                            <img src={data.imgSrc} width="55" height="48" class="d-inline-block align-top" alt="" loading="lazy" />
                          </div>
                        </div>
                        <p class="homecardt">{data.title}</p>
                      </Link>
                    </div>
                  )
                })}
              {this.props.userProfileDataR?.userType === "Preview" &&
                this.state.previewTiles?.map((data, index) => {
                  return (
                    <div className='rectangle4' onClick={() => this.tilesAccess(data.tileUserType)}>
                      <Link to={data?.functionId == 20 ?
                        this.props.manageProfileDataR?.selectedProfileType === "Requester"
                          ? "/preferencesRequester" : (this.props.manageProfileDataR?.selectedProfileType === "Respondent"
                            ? "/preferencesRespondent" :
                            (this.props.manageProfileDataR?.selectedProfileType === "Driver" ? "/preferencesDriver" : ''))
                        :
                        data.destPage} className="decoration" style={{ textDecoration: 'none' }}>
                        <div className="card4">
                          <div class="tileicons">
                            <img src={data.imgSrc} width="55" height="48" class="d-inline-block align-top" alt="" loading="lazy" />
                          </div>
                        </div>
                        <p class="homecardt">{data.title}</p>
                      </Link>
                    </div>
                  )
                })}
              <div className='rectangle4'></div>
            </div>
          </div>
        </div>
        <Footer />
        {this.state.hashOPenValue &&
          <ProfileModal hasOpen={this.state.hasOpen} onCloseModal={this.onCloseModal} AddProfile={this.onAddProfile}
            profileCheck={this.profileCheck}
          />
        }
      </div>
    );
  }
}
function mapStateToProps(state) {
  if (state.userProfileInfoReducer.data) {
    return {
    userProfileDataR:JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8)),
      manageProfileDataR: state.manageProfileReducer.data
    }
  }
}
export default connect(mapStateToProps)(Home);
